<div class="social-media-location-container">
  <div
    class="d-flex flex-column flex-md-row justify-content-between align-items-between"
  >
    <div class="d-flex flex-column align-items-start">
      <p class="subtitle">
        <span>
          {{ 'LOCATIONS.ACTIVATE_YOUR_LOCATIONS' | translate }}
          @if (brand?.name) {
            {{ 'GENERAL.FOR' | translate }} "{{ brand?.name }}"
          }
        </span>
      </p>

      <p class="description">
        {{ 'LOCATIONS.ACTIVATE_YOUR_LOCATIONS_DESCRIPTION' | translate }}
      </p>
    </div>

    <div class="d-flex align-items-start justify-content-center">
      <app-geo-loader
        *ngIf="isLoading"
        [showBg]="true"
        [textToDisplay]="'LOCATIONS.ACTIVATE_YOUR_LOCATIONS_SYNCED' | translate"
      ></app-geo-loader>

      <button (click)="skipStep()" class="text-button skip">
        {{ cancelLabel }}
      </button>

      <button
        class="primary-button"
        (click)="continue()"
        [disabled]="selection.isEmpty() || isLoading"
      >
        {{ activateLocationsLabel }}
      </button>
    </div>
  </div>

  <mat-form-field>
    <mat-label>{{ 'GENERAL.SEARCH' | translate }}</mat-label>
    <input
      matInput
      (keyup)="searchField($event)"
      placeholder=" {{ 'LOCATIONS.SEARCH_FOR_LOCATION' | translate }}"
    />
  </mat-form-field>

  <div class="table-wrapper">
    <div class="table-container">
      <table mat-table [dataSource]="dataSource">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              color="primary"
              (change)="$event ? toggleAllRows() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
            >
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox
              color="primary"
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row.id) : null"
              [checked]="selection.isSelected(row.id)"
            >
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="locations">
          <th mat-header-cell *matHeaderCellDef>
            <p class="header-title">
              <span>{{ 'LOCATIONS.LOCATIONS' | translate }}</span>
            </p>
          </th>
          <td mat-cell *matCellDef="let element">
            <span class="notranslate">{{ element.name }}</span>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
          [ngClass]="{ select: selection.hasValue() }"
        ></tr>

        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="selection.toggle(row.id)"
          [ngClass]="{ select: selection.isSelected(row.id) }"
        ></tr>
      </table>
    </div>

    <div class="footer-counter">
      <p *ngIf="selection.selected.length > 0">
        <span *ngIf="selection.selected.length === 1"
          ><span class="notranslate"
            >{{ selection.selected.length | numberTranslate }} </span
          >{{ 'LOCATIONS.LOCATION_SELECTED' | translate }}
        </span>

        <span *ngIf="selection.selected.length > 1"
          ><span class="notranslate"
            >{{ selection.selected.length | numberTranslate }} </span
          >{{ 'LOCATIONS.LOCATION_SELECTED' | translate }}</span
        >
      </p>
    </div>
  </div>
</div>
